import script from "./hot.vue?vue&type=script&setup=true&lang=js"
export * from "./hot.vue?vue&type=script&setup=true&lang=js"

import "./hot.vue?vue&type=style&index=0&id=770e79be&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-770e79be"]])

export default __exports__